import { type AxiosInstance } from "axios";

import type {
  CloudFlowDetailsResponse,
  InsightCloudFlowsResponse,
  InsightMissingPermissionsResponse,
  InsightResultsResponse,
  ServerInsight,
} from "./types";

type GetInsightsProps = {
  customerId: string;
};

type GetCloudFlowsProps = {
  customerId: string;
  providerId: string;
  insightKey: string;
};

type GetCloudFlowDetailsProps = {
  customerId: string;
  cloudflowId: string;
};

export const createInsight = async (api: AxiosInstance, { insight }) => api.post(`/insights/results`, insight);

export const getInsights = async (api: AxiosInstance, { customerId }: GetInsightsProps) => {
  const response = await api.get<InsightResultsResponse<ServerInsight>>("insights/results", {
    params: { customerID: customerId },
  });

  return response.data;
};

export const getInsightsMissingPermissions = async (api: AxiosInstance, { customerId }: GetInsightsProps) => {
  const response = await api.get<InsightMissingPermissionsResponse>("insights/missing-permissions", {
    params: { customerID: customerId },
  });

  return response.data;
};

type PostInsightEnhancementProps = {
  customerId: string;
  providerId: string;
  insightKey: string;
  priority?: string;
  tags?: string[];
  expertNote?: string;
};

export const postInsightEnhancement = async (
  api: AxiosInstance,
  { customerId, providerId, insightKey, priority, tags, expertNote }: PostInsightEnhancementProps
) =>
  api.post<null>(`/insights/customers/${customerId}/provider/${providerId}/insight/${insightKey}/metadata`, {
    priority,
    tags,
    expertNote,
  });

export const sendUpsellUpgradeNotification = async ({ api, customerID }) =>
  api.post(`/insights/notification/upsell-upgrade?customerID=${customerID}`);

export const getInsightCloudFlows = async (
  api: AxiosInstance,
  { customerId, providerId, insightKey }: GetCloudFlowsProps
) => {
  const response = await api.get<InsightCloudFlowsResponse>(
    `insights/customers/${customerId}/provider/${providerId}/insight/${insightKey}/cloudflows`
  );

  return response.data;
};

export const getCloudFlowDetails = async (
  api: AxiosInstance,
  { customerId, cloudflowId }: GetCloudFlowDetailsProps
) => {
  const response = await api.get<CloudFlowDetailsResponse>(
    `/v1/customers/${customerId}/cloudflow/${cloudflowId}?nodes=false`
  );

  return response.data;
};
